export default "__VITE_ASSET__d4d732b7__"